import { render } from "./pwdReset.vue?vue&type=template&id=0b5d45af&scoped=true"
import script from "./pwdReset.vue?vue&type=script&lang=js"
export * from "./pwdReset.vue?vue&type=script&lang=js"

import "./pwdReset.vue?vue&type=style&index=0&id=0b5d45af&lang=less&scoped=true"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5d45af"]])

export default __exports__